import React from "react";
import { Users } from "lucide-react";
import { usePartyStore } from "../../stores/partyStore";
import { UserAvatar } from "../common/UserAvatar";

export const PartyMembersList: React.FC = () => {
  const { members } = usePartyStore();

  if (members.length === 0) return null;

  return (
    <div className="flex items-center gap-3 py-2 overflow-x-auto select-none no-scrollbar">
      <div className="flex items-center gap-1 text-xs font-bold font-heading text-text-muted shrink-0 pr-1">
        <Users className="w-4 h-4 text-accent" />
        <span>{members.length}</span>
      </div>

      <div className="flex items-center gap-2">
        {members.map((m) => (
          <div
            key={m.uid}
            className="flex items-center gap-2 bg-card border border-border px-2.5 py-1 rounded-full shrink-0 shadow-sm"
            title={`${m.name} (${m.role})`}
          >
            <UserAvatar
              photoURL={m.photoURL}
              name={m.name}
              uid={m.uid}
              size="xs"
              isHost={m.role === "HOST"}
            />
            <span className="text-xs font-semibold text-text-main max-w-[90px] truncate">
              {m.name}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
